import { AngularEditorConfig } from '@kolkov/angular-editor';

export function initializeEditor(): AngularEditorConfig {
    return {
        editable: true,
        spellcheck: true,
        height: 'auto',
        minHeight: '200px',
        maxHeight: 'auto',
        width: 'auto',
        minWidth: '0',
        translate: 'yes',
        enableToolbar: true,
        showToolbar: true,
        placeholder: 'Introduceți textul dorit...',
        defaultParagraphSeparator: 'p',
        defaultFontName: '',
        defaultFontSize: '3',
        fonts: [
            { class: 'arial', name: 'Arial' },
            { class: 'times-new-roman', name: 'Times New Roman' },
            { class: 'calibri', name: 'Calibri' },
            { class: 'comic-sans-ms', name: 'Comic Sans MS' },
        ],
        sanitize: true,
        toolbarPosition: 'top',
        toolbarHiddenButtons: [['insertImage', 'insertVideo']],
    };
}
